// src/data/portfolioMedia.js
// Fonte única para mídias do Portfólio.
// As páginas (Portfólio / Cenografia / Iluminação) reutilizam essas listas.

export const portfolioMedia = {
  cenografia: [
    {
      src: "/images/portfolio/cenografia/01.png",
      alt: "Cenografia Cenovix em evento corporativo com leitura de marca",
      caption: "Leitura de marca e presença",
    },
    {
      src: "/images/portfolio/cenografia/02.png",
      alt: "Cenografia Cenovix com foco em materiais e acabamento premium",
      caption: "Materiais e acabamento",
    },
    {
      src: "/images/portfolio/cenografia/03.png",
      alt: "Montagem de cenografia Cenovix com estrutura e segurança",
      caption: "Estrutura e montagem",
    },
    {
      src: "/images/portfolio/cenografia/04.png",
      alt: "Cenografia Cenovix — projeto 4",
      caption: "Projeto 4",
    },
    {
      src: "/images/portfolio/cenografia/05.png",
      alt: "Cenografia Cenovix — projeto 5",
      caption: "Projeto 5",
    },
    {
      src: "/images/portfolio/cenografia/06.png",
      alt: "Cenografia Cenovix — projeto 6",
      caption: "Projeto 6",
    },
    {
      src: "/images/portfolio/cenografia/07.png",
      alt: "Cenografia Cenovix — projeto 7",
      caption: "Projeto 7",
    },
    {
      src: "/images/portfolio/cenografia/08.png",
      alt: "Cenografia Cenovix — projeto 8",
      caption: "Projeto 8",
    },
    {
      src: "/images/portfolio/cenografia/09.png",
      alt: "Cenografia Cenovix — projeto 9",
      caption: "Projeto 9",
    },
    {
      src: "/images/portfolio/cenografia/10.png",
      alt: "Cenografia Cenovix — projeto 10",
      caption: "Projeto 10",
    },
    {
      src: "/images/portfolio/cenografia/11.png",
      alt: "Cenografia Cenovix — projeto 11",
      caption: "Projeto 11",
    },
    {
      src: "/images/portfolio/cenografia/12.png",
      alt: "Cenografia Cenovix — projeto 12",
      caption: "Projeto 12",
    },
    {
      src: "/images/portfolio/cenografia/13.png",
      alt: "Cenografia Cenovix — projeto 13",
      caption: "Projeto 13",
    },
  ],

  iluminacao: [
    { src: "/images/portfolio/iluminacao/01.jpg", alt: "Iluminação cênica Cenovix — projeto 1" },
    { src: "/images/portfolio/iluminacao/02.jpg", alt: "Iluminação cênica Cenovix — projeto 2" },
    { src: "/images/portfolio/iluminacao/03.jpg", alt: "Iluminação cênica Cenovix — projeto 3" },
    { src: "/images/portfolio/iluminacao/04.jpg", alt: "Iluminação cênica Cenovix — projeto 4" },
    { src: "/images/portfolio/iluminacao/05.jpg", alt: "Iluminação cênica Cenovix — projeto 5" },
    { src: "/images/portfolio/iluminacao/06.jpg", alt: "Iluminação cênica Cenovix — projeto 6" },
    { src: "/images/portfolio/iluminacao/07.jpg", alt: "Iluminação cênica Cenovix — projeto 7" },
    { src: "/images/portfolio/iluminacao/08.jpg", alt: "Iluminação cênica Cenovix — projeto 8" },
    { src: "/images/portfolio/iluminacao/09.jpg", alt: "Iluminação cênica Cenovix — projeto 9" },
    { src: "/images/portfolio/iluminacao/10.jpg", alt: "Iluminação cênica Cenovix — projeto 10" },
    { src: "/images/portfolio/iluminacao/11.jpg", alt: "Iluminação cênica Cenovix — projeto 11" },
    { src: "/images/portfolio/iluminacao/12.jpg", alt: "Iluminação cênica Cenovix — projeto 12" },
    { src: "/images/portfolio/iluminacao/13.jpg", alt: "Iluminação cênica Cenovix — projeto 13" },
    { src: "/images/portfolio/iluminacao/14.jpg", alt: "Iluminação cênica Cenovix — projeto 14" },
  ],
};
